import { ApiRoutes } from "consts/enpoints/api"
import { fetchApi } from "infrastructure/api"

export const getPayoutAccounts = () =>
    fetchApi(ApiRoutes.GetPayoutAccounts());

export const getPayoutCryptoAccounts = () =>
    fetchApi(ApiRoutes.GetPayoutCryptoAccounts());
